import React, { useEffect, useState } from 'react'
import {
	CheckboxUnit,
	DBFilterCheckboxArea,
	DBFilterDateArea,
	DBFilterWrapper,
	DBTableBtn,
	DBTableExcelBtn,
	DBTableResultTxt,
} from './styles'
import { Icon } from '../Main/styles'
import { FaRegFileExcel } from 'react-icons/fa'
import { TopBoxTitle } from '../Home/styles'
import { Checkbox, Select, Table, message } from 'antd'
import { useDBList } from 'CRM/hooks/GetDBTable'
import DBInput from 'CRM/components/DB/DBInput'
import DBUserInfo from 'CRM/components/DB/DBUserInfo'
import { useStatusList } from 'CRM/hooks/GetStatusList'
import API from 'utils/api'
import { useToken } from 'app/hooks'
import TotalStatusChange from 'CRM/components/DB/TotalStatusChange'
import TotalAccessPathChange from 'CRM/components/DB/TotalAccessPathChange'
import TotalDistribution from 'CRM/components/DB/TotalDistribution'
import { useMyInfo } from '../../hooks/GetMyInfo'
import {useIsMobile} from "../../components/IsMobile";

export const DBTable = ({
	pathList,
	resList,
	teamList,
	createdAt,
	assignedAt,
	updatedAt,
	name,
	tel,
	path,
	respon,
	team,
	selectedRows,
}) => {
	const IsMobile = useIsMobile();
	const [scrollPosition, setScrollPosition] = useState(0);
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);

	const { dbList, total, mutate } = useDBList(
		selectedRows,
		team == '' ? '' : teamList?.find(it => it.name == team)?.id,
		respon == '' ? '' : resList?.find(it => it.name == respon)?.id,
		createdAt?.[0] == null
			? ''
			: `${createdAt?.[0]?.format('YYYY-MM-DD') + '~' + createdAt?.[1]?.format('YYYY-MM-DD')}`,
		assignedAt?.[0] == null
			? ''
			: `${assignedAt?.[0]?.format('YYYY-MM-DD') + '~' + assignedAt?.[1]?.format('YYYY-MM-DD')}`,
		updatedAt?.[0] == null
			? ''
			: `${updatedAt?.[0]?.format('YYYY-MM-DD') + '~' + updatedAt?.[1]?.format('YYYY-MM-DD')}`,
		name,
		tel,
		path == '' ? '' : pathList?.find(it => it.name == path)?.id,
		page, pageSize
	)
	const { data: token } = useToken();
	const { statusList } = useStatusList();

	const { myInfo } = useMyInfo();
	const [selectTable, setSelectTable] = useState<number[]>([])
	const [isAllChecked, setIsAllChecked] = useState(false)

	const [isDBInput, setIsDBInput] = useState(false)
	const [isUserSelect, setIsUserSelect] = useState(false)
	const [userId, setUserId] = useState()

	const [isTotalStatus, setIsTotalStatus] = useState(false)
	const [isTotalAccessPath, setIsTotalAccessPath] = useState(false)
	const [isDistribution, setIsDistribution] = useState(false)

	useEffect(() => {
		if(!isUserSelect && IsMobile){
			window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
		} else if(isUserSelect && IsMobile) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
			setScrollPosition(window.scrollY);
		}
	}, [isUserSelect]);


	useEffect(() => {
		const allSelected = dbList?.length > 0 && dbList?.every(it => selectTable?.includes(it.id))
		setIsAllChecked(allSelected)
	}, [selectTable, dbList])

	const handleCheckboxChange = (e, id) => {
		if (e.target.checked) {
			setSelectTable([...selectTable, id])
		} else {
			setSelectTable(selectTable?.filter(rowId => rowId !== id))
		}
	}

	const handleSelectAllChange = e => {
		setIsAllChecked(e.target.checked)
		const ids = dbList?.map(db => db.id)
		setSelectTable(e.target.checked ? Array.from(new Set([...selectTable, ...ids])) : [])
	}

	const editStatus = (e, data) => {
		const shouldEdit = window.confirm(
			`${data?.name}님의 상태를 ${statusList?.find(it => it.id == e)?.name}로 변경하시겠습니까?`
		)
		if (shouldEdit) {
			API.put('/users/' + data?.id, token + '', {
				datas: {
					statusId: e,
				},
			})
				.then((res: any) => {
					if (res.result.success) {
						message.success('수정되었습니다')
						mutate()
					}
				})
				.catch((err: any) => {})
		}
	}

	const excelDownAll = () => {
		const shouldEdit = window.confirm(`전체 DB 목록을 다운받으시겠습니까?`)
		if (shouldEdit) {
			API.post(
				'/users/excel?page=1&maxData=99999999&statusId=' +
					selectedRows.join(',') +
					'&teamId=' +
					(team == '' ? '' : teamList?.find(it => it.name == team)?.id) +
					'&responsibilityId=' +
					(respon == '' ? '' : resList?.find(it => it.name == respon)?.id) +
					'&createdAt=' +
					(createdAt?.[0] == null
						? ''
						: `${
								createdAt?.[0]?.format('YYYY-MM-DD') + '~' + createdAt?.[1]?.format('YYYY-MM-DD')
						  }`) +
					'&assignedAt=' +
					(assignedAt?.[0] == null
						? ''
						: `${
								assignedAt?.[0]?.format('YYYY-MM-DD') + '~' + assignedAt?.[1]?.format('YYYY-MM-DD')
						  }`) +
					'&updatedAt=' +
					(updatedAt?.[0] == null
						? ''
						: `${
								updatedAt?.[0]?.format('YYYY-MM-DD') + '~' + updatedAt?.[1]?.format('YYYY-MM-DD')
						  }`) +
					'&customerName=' +
					name +
					'&tel=' +
					tel +
					'&accessPathId=' +
					(path == '' ? '' : pathList?.find(it => it.name == path)?.id),
				token + '',
				{
					ids: [],
				}
			)
				.then((res: any) => {
					if (res.result.success) {
						window.open(res.result.result.link, '_blank')
					}
				})
				.catch((err: any) => {})
		}
	}

	const excelDownSelect = () => {
		const shouldEdit = window.confirm(`선택한 DB 목록을 다운받으시겠습니까?`)
		if (shouldEdit) {
			API.post(
				'/users/excel?page=1&maxData=99999999&statusId=' +
					selectedRows.join(',') +
					'&teamId=' +
					(team == '' ? '' : teamList?.find(it => it.name == team)?.id) +
					'&responsibilityId=' +
					(respon == '' ? '' : resList?.find(it => it.name == respon)?.id) +
					'&createdAt=' +
					(createdAt?.[0] == null
						? ''
						: `${
								createdAt?.[0]?.format('YYYY-MM-DD') + '~' + createdAt?.[1]?.format('YYYY-MM-DD')
						  }`) +
					'&assignedAt=' +
					(assignedAt?.[0] == null
						? ''
						: `${
								assignedAt?.[0]?.format('YYYY-MM-DD') + '~' + assignedAt?.[1]?.format('YYYY-MM-DD')
						  }`) +
					'&updatedAt=' +
					(updatedAt?.[0] == null
						? ''
						: `${
								updatedAt?.[0]?.format('YYYY-MM-DD') + '~' + updatedAt?.[1]?.format('YYYY-MM-DD')
						  }`) +
					'&customerName=' +
					name +
					'&tel=' +
					tel +
					'&accessPathId=' +
					(path == '' ? '' : pathList?.find(it => it.name == path)?.id),
				token + '',
				{
					ids: selectTable,
				}
			)
				.then((res: any) => {
					if (res.result.success) {
						window.open(res.result.result.link, '_blank')
					}
				})
				.catch((err: any) => {})
		}
	}

	const userDelete = () => {
		const shouldEdit = window.confirm(`선택한 DB를 삭제하시겠습니까?`)
		if (shouldEdit) {
			if (selectTable?.length == 0) {
				message.error('선택한 DB가 없습니다.')
			} else {
				API.post('/users/delete', token + '', {
					ids: selectTable
				})
					.then((res: any) => {
						if (res.result.success) {
							message.success('삭제되었습니다.')
						}
					})
					.catch((err: any) => {})
			}
		}
	}

	const handleTableChange = (pagination) => {
		setPage(pagination.current);
		setPageSize(pagination.pageSize);
	};

	const mobileColumns = [
		{
			dataIndex: 'checkbox',
			title: <Checkbox checked={isAllChecked} onChange={handleSelectAllChange} />,
			render: (value, data) => {
				return (
					<div
						className="checkbox"
						style={{
							textAlign: 'center',
							backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
						}}>
						<Checkbox
							checked={selectTable?.includes(data.id)}
							key={data?.id}
							onChange={e => handleCheckboxChange(e, data?.id)}
						/>
					</div>
				)
			},
		},
		{
			dataIndex: '',
			title: 'DB 리스트',
			render: (value, data) => {
				return (
					<>
						<p
							className="name"
							onClick={() => {
								setIsUserSelect(true)
								setUserId(data?.id)
							}}
							style={{
								color: '#437EFF',
								cursor: 'pointer',
								backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
								display: "flex",
								justifyContent: 'flex-start',
								paddingLeft: 10,
								paddingTop: 20
							}}>
							<p style={{marginRight: 5, fontWeight: 'bold'}}>이름: </p>
							{data?.name || '-'}
						</p>
						<p
							className="tel"
							style={{
								backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
								display: "flex",
								justifyContent: 'flex-start',
								paddingLeft: 10,
							}}>
							<p style={{marginRight: 5, fontWeight: 'bold', color: 'black'}}>연락처: </p>
							{data?.tel || '-'}
						</p>
						<p
							className="path"
							style={{
								backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
								display: "flex",
								justifyContent: 'flex-start',
								paddingLeft: 10,
							}}>
							<p style={{marginRight: 5, fontWeight: 'bold', color: 'black'}}>방문경로: </p>
							{data?.accessPathName || '-'}
						</p>
						<p
							className="status"
							style={{
								textAlign: 'center',
								backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
								display: "flex",
								justifyContent: 'flex-start',
								alignItems: "center",
								paddingLeft: 10,
							}}>
							<p style={{fontWeight: 'bold', color: 'black'}}>상태: </p>
							<Select
								value={data?.statusId == null ? '대기' : data?.statusId}
								onChange={e => editStatus(e, data)}
								style={{ fontFamily: 'Pretendard', minWidth: 100, height: 20, marginLeft: 10 }}>
								<option value={'0'}>대기</option>
								{statusList?.map(it => (
									<option value={it.id} style={{ fontFamily: 'Pretendard' }}>{it.name}
									</option>
								))}
							</Select>
						</p>
						<p
							className="manager"
							style={{
								backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
								display: "flex",
								justifyContent: 'flex-start',
								paddingLeft: 10,
							}}>
							<p style={{marginRight: 5, fontWeight: 'bold', color: 'black'}}>담당자: </p>
							{data?.responsibilityName || '-'}
						</p>
						<p
							className="date"
							style={{
								backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
								display: "flex",
								justifyContent: 'flex-start',
								paddingLeft: 10,
							}}>
							<p style={{marginRight: 5, fontWeight: 'bold', color: 'black'}}>배정일: </p>
							{data?.assignedAt || '-'}
						</p>
						<p
							className="date"
							style={{
								backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
								display: "flex",
								justifyContent: 'flex-start',
								paddingLeft: 10,
							}}>
							<p style={{marginRight: 5, fontWeight: 'bold', color: 'black'}}>등록일: </p>
							{data?.createdAt || '-'}
						</p>
						<p
							className="memo"
							style={{
								backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
								display: "flex",
								justifyContent: 'flex-start',
								minHeight: 43,
								paddingLeft: 10
							}}>
							<p style={{marginRight: 5, fontWeight: 'bold', color: 'black', minWidth: 30}}>메모: </p>
							{data?.memo || '-'}
						</p>



					</>
				)
			},
		},
	]

	const columns = [
		{
			dataIndex: 'checkbox',
			title: <Checkbox checked={isAllChecked} onChange={handleSelectAllChange} />,
			render: (value, data) => {
				return (
					<div
						className="checkbox"
						style={{
							textAlign: 'center',
							backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
							padding: 10,
						}}>
						<Checkbox
							checked={selectTable?.includes(data.id)}
							key={data?.id}
							onChange={e => handleCheckboxChange(e, data?.id)}
						/>
					</div>
				)
			},
		},
		{
			dataIndex: '',
			title: '이름',
			render: (value, data) => {
				return (
					<div
						className="name"
						onClick={() => {
							setIsUserSelect(true)
							setUserId(data?.id)
						}}
						style={{
							color: '#437EFF',
							textDecoration: 'underline',
							cursor: 'pointer',
							backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
							padding: 10,
							whiteSpace: 'nowrap'
						}}>
						{data?.name}
					</div>
				)
			},
		},
		{
			dataIndex: '',
			title: '연락처',
			render: (value, data) => {
				return (
					<div
						className="tel"
						style={{
							backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
							padding: 10,
							whiteSpace: 'nowrap'
						}}>
						{data?.tel}
					</div>
				)
			},
		},
		{
			dataIndex: '',
			title: '방문경로',
			render: (value, data) => {
				return (
					<div
						className="path"
						style={{
							backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
							padding: 10,
							whiteSpace: 'nowrap'
						}}>
						{data?.accessPathName}
					</div>
				)
			},
		},
		{
			dataIndex: '',
			title: '상태',
			render: (value, data) => {
				// console.log(data?.statusId)
				return (
					<div
						className="status"
						style={{
							textAlign: 'center',
							backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
							padding: 5,
							whiteSpace: 'nowrap'
						}}>
						<Select
							value={data?.statusId == null ? '대기' : data?.statusId}
							onChange={e => editStatus(e, data)}
							style={{ fontFamily: 'Pretendard', minWidth: 100 }}>
							<option value={'0'}>대기</option>
							{statusList?.map(it => (
								<option value={it.id} style={{ fontFamily: 'Pretendard' }}>
									{it.name}
								</option>
							))}
						</Select>
					</div>
				)
			},
		},
		{
			dataIndex: '',
			title: '담당자',
			render: (value, data) => {
				return (
					<div
						className="manager"
						style={{
							backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
							padding: 10,
							whiteSpace: 'nowrap'
						}}>
						{data?.responsibilityName}
					</div>
				)
			},
		},
		{
			dataIndex: '',
			title: '배정일',
			render: (value, data) => {
				return (
					<div
						className="date"
						style={{
							backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
							padding: 10,
							whiteSpace: 'nowrap'
						}}>
						{data?.assignedAt}
					</div>
				)
			},
		},
		{
			dataIndex: '',
			title: '등록일',
			render: (value, data) => {
				return (
					<div
						className="date"
						style={{
							backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
							padding: 10,
							whiteSpace: 'nowrap'
						}}>
						{data?.createdAt}
					</div>
				)
			},
		},
		{
			dataIndex: '',
			title: '메모',
			render: (value, data) => {
				return (
					<div
						className="memo"
						style={{
							backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,
							padding: 10,
							height: 43,
						}}>
						{data?.memo}
					</div>
				)
			},
		},
	]

	const clickTotalStatus = () => {
		if (selectTable.length == 0) {
			message.error('일괄상태변경 하실 DB를 선택해주세요.')
		} else {
			setIsTotalStatus(true)
		}
	}

	const clickTotalAccessPath = () => {
		if (selectTable.length == 0) {
			message.error('일괄출처변경 하실 DB를 선택해주세요.')
		} else {
			setIsTotalAccessPath(true)
		}
	}

	const clickDistribution = () => {
		if (selectTable.length == 0) {
			message.error('DB배분 하실 DB를 선택해주세요.')
		} else {
			setIsDistribution(true)
		}
	}

	return (
		<DBFilterWrapper IsMobile={IsMobile}>
			{IsMobile ?
				<DBFilterCheckboxArea IsMobile={IsMobile}>
					<CheckboxUnit IsMobile={IsMobile}>
						<DBTableBtn border="blue" color="blue" IsMobile={IsMobile}>
							선택디비회수
						</DBTableBtn>
						<DBTableBtn border="red" color="red" onClick={userDelete} IsMobile={IsMobile}>
							선택디비삭제
						</DBTableBtn>
					</CheckboxUnit>

					<CheckboxUnit IsMobile={IsMobile}>
						<DBTableBtn border="purple" color="purple" onClick={clickDistribution} IsMobile={IsMobile}>
							DB배분
						</DBTableBtn>
						<DBTableBtn onClick={() => setIsDBInput(true)} border="orange" color="orange" IsMobile={IsMobile}>
							DB직접입력
						</DBTableBtn>
					</CheckboxUnit>

					<CheckboxUnit IsMobile={IsMobile}>
						<DBTableBtn border="green" color="green" onClick={clickTotalStatus} IsMobile={IsMobile}>
							일괄상태변경
						</DBTableBtn>
						<DBTableBtn border="#E91E63" color="#E91E63" onClick={clickTotalAccessPath} IsMobile={IsMobile}>
							일괄출처변경
						</DBTableBtn>
					</CheckboxUnit>
					<CheckboxUnit>
						{myInfo.master && (
							<>
								<DBTableBtn border="green" color="green" onClick={excelDownAll} IsMobile={IsMobile}>
									엑셀다운로드
								</DBTableBtn>
								<DBTableBtn border="green" color="green" onClick={excelDownSelect} IsMobile={IsMobile}>
									선택 다운로드
								</DBTableBtn>
							</>
						)}

						<DBTableResultTxt IsMobile={IsMobile}>
							조회결과: 총 <span>{total || 0}</span> 명
						</DBTableResultTxt>
					</CheckboxUnit>
				</DBFilterCheckboxArea>
				:
				<DBFilterCheckboxArea>
					<CheckboxUnit>
						<DBTableBtn border="blue" color="blue">
							선택디비회수
						</DBTableBtn>
						<DBTableBtn border="red" color="red" onClick={userDelete}>
							선택디비삭제
						</DBTableBtn>
						<DBTableBtn border="purple" color="purple" onClick={clickDistribution}>
							DB배분
						</DBTableBtn>
						<DBTableBtn onClick={() => setIsDBInput(true)} border="orange" color="orange">
							DB직접입력
						</DBTableBtn>
						<DBTableBtn border="green" color="green" onClick={clickTotalStatus}>
							일괄상태변경
						</DBTableBtn>
						<DBTableBtn border="#E91E63" color="#E91E63" onClick={clickTotalAccessPath}>
							일괄출처변경
						</DBTableBtn>
					</CheckboxUnit>
					<CheckboxUnit>
						{myInfo.master && (
							<>
								<DBTableExcelBtn onClick={excelDownAll}>
									<Icon>
										<FaRegFileExcel />
									</Icon>
									엑셀다운로드
								</DBTableExcelBtn>
								<DBTableExcelBtn onClick={excelDownSelect}>
									<Icon>
										<FaRegFileExcel />
									</Icon>
									선택 다운로드
								</DBTableExcelBtn>
							</>
						)}

						<DBTableResultTxt>
							조회결과: 총 <span>{total || 0}</span> 명
						</DBTableResultTxt>
					</CheckboxUnit>
				</DBFilterCheckboxArea>
			}


			<Table
				className="DBTable"
				dataSource={dbList}
				columns={ IsMobile ? mobileColumns : columns}
				bordered={true}
				pagination={{
					current: page,
					pageSize: pageSize,
					total: total,
				}}
				onChange={handleTableChange}
			/>

			{isDBInput && <DBInput setIsDBInput={setIsDBInput} pathList={pathList} resList={resList} />}
			{isUserSelect && (
				<DBUserInfo
					setIsUserSelect={setIsUserSelect}
					pathList={pathList}
					resList={resList}
					userId={userId}
				/>
			)}
			{isTotalStatus && (
				<TotalStatusChange
					selectTable={selectTable}
					setSelectTable={setSelectTable}
					setIsTotalStatus={setIsTotalStatus}
					dbList={dbList}
					mutate={mutate}
					statusList={statusList}
				/>
			)}
			{isTotalAccessPath && (
				<TotalAccessPathChange
					selectTable={selectTable}
					setSelectTable={setSelectTable}
					setIsTotalAccessPath={setIsTotalAccessPath}
					mutate={mutate}
					pathList={pathList}
				/>
			)}
			{isDistribution && (
				<TotalDistribution
					selectTable={selectTable}
					setSelectTable={setSelectTable}
					setIsDistribution={setIsDistribution}
					mutate={mutate}
					resList={resList}
				/>
			)}
		</DBFilterWrapper>
	)
}

export default React.memo(DBTable)
